import { FC } from 'react';

import Box from '@mui/material/Box';

import etg from 'assets/integration-icons/etg.png';
import facebook from 'assets/integration-icons/facebook.png';
import google from 'assets/integration-icons/google.png';
import kiwi from 'assets/integration-icons/kiwi.png';
import paysera from 'assets/integration-icons/paysera.png';
import waawo from 'assets/integration-icons/waavo.png';
import scoroLight from 'assets/integration-icons/scoro-light.png';
import scoroDark from 'assets/integration-icons/scoro-dark.png';
import { useTheme } from '@mui/material/styles';

const icons = {
  etg: {
    dark: etg,
    light: etg,
  },
  facebook: {
    dark: facebook,
    light: facebook,
  },
  google: {
    dark: google,
    light: google,
  },
  kiwi: {
    dark: kiwi,
    light: kiwi,
  },
  paysera: {
    dark: paysera,
    light: paysera,
  },
  waawo: {
    dark: waawo,
    light: waawo,
  },
  scoro: {
    dark: scoroDark,
    light: scoroLight,
  },
};

type Props = {
  integration: keyof typeof icons;
};

const IntegrationIcon: FC<Props> = ({ integration }) => {
  const { light, dark } = icons[integration];

  const {
    palette: { mode },
  } = useTheme();

  return (
    <Box sx={{ maxHeight: '20px', maxWidth: '100px', pr: 2, pl: 2 }}>
      <img
        src={mode === 'light' ? light : dark}
        alt={integration}
        style={{ height: '100%' }}
      />
    </Box>
  );
};

export default IntegrationIcon;
